// Styled Components
import styled from "styled-components";

// Components
import FaqItem from "./FaqItem/FaqItem";

const Faq = () => {
  return (
    <Wrapper>
      <p className="header">FAQ</p>
      <FaqItem
        header={"HOW NFTS WORK IN THE SHOEUZIVERSE"}
        info={`There are 2 kinds of NFTs in the shoueuziverse: Scattered 2d illustrated shoeuzi's that have been deconstructured into 4 pieces Complete 3D rendered complete desgins, which will in the future be usable in the multiplayer first person shooter game when the shoeuziverse was created all COMPLETE shoeuzis were deconstructured and scattered across the metaverse. You need to hunt them down and put them back together`}
      />
      <FaqItem
        header={"SCATTERED TRAITS"}
        info={`The traits of each NFT say what parts of a COMPLETE shoeuzi it is made from (eg. HANDLE: "Justice"). Once you have collected all parts, you will be given the COMPLETE NFT. This is the only way to get COMPLETE NFTs which makes COMPLETE shoeuzi NFTs rare. COMPLETE NFT's are composed of 4 traits.`}
      />
      <FaqItem
        header={"HOW COMPLETE NFTS WORK"}
        info={`When changing Scattered NFTs into Complete ones, you can only pick 1 complete design from that Scattered nft's traits to actively use. (eg. if your Scattered nft has; Upper: Justice & Mid: Justice, you can use both of those traits to count towards a Complete Marge. When you generate a Complete NFT the scattered ones you used to generate it get burnt. This means that they are transfered to a dead wallet and are no longer in the game. At the end of the game on March 5th, players who have 10+ COMPLETE designs will be allowed to mint one of them in the real world! This will be a 1 of 1, signed, real, resin casted shoeuzi. A lot of the NFT shoeuzis are NFT original designs and have never been made in the physical world, tso they will be one of a kind pieces. This will be made and delivered to you (1-2month) for free. COMPLETE NFTs also have their own traits, the main one to look out for is the Rarity: The rarities are: Uncommon Common Rare Epic These traits will be used in the game we are developing, the rarity will translate to the amount of damage your shoeuzi has in the arena `}
      />
      <FaqItem
        header={"HOW TO GENERATE A COMPLETE"}
        info={`Coming soon!`}
      />
    </Wrapper>
  );
};

export default Faq;

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  padding: 0 20px;
  padding-top: 100px;

  background-color: #000;

  .header {
    font-family: "Pixeltype";
    font-weight: 200;

    font-size: 2rem;
    line-height: 48px;
  }
`;
